// log-messages
export const REQUEST_ERROR = 'request error';
export const REQUEST_RETRY = 'request retry';
export const RESPONSE_RECEIVED = 'response received';
export const SENDING_REQUEST = 'sending request';
export const RATE_LIMIT_RESPONSE_RECEIVED = 'rate limit response received';
